import { AutoCompleteComponent } from "@syncfusion/ej2-react-dropdowns";
import React, { Component } from "react";
// import DatePicker from 'react-datepicker2';
import moment from "moment-jalaali";
import NumberFormat from "react-number-format";
// import ToggleButton from '../components/ToggleButton'
import { Redirect } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import dateicon from "../assets/dateicon.png";
import { toast } from "react-toastify";

import DatePicker, { DateObject } from "react-multi-date-picker";
// import Toolbar from "react-multi-date-picker/plugins/toolbar"
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/colors/bluee.css";

export default class BrokerBenefit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedBasket: "",
      selectedBroker: "",
      chashchange: "",
      dateValue: moment().format("jYYYY/jMM/jDD"),
      maxDateStart: moment().add(0, "days").format("jYYYY/jMM/jDD"),
      // InValue:true,
      // OutValue:false,
      basketValue: "",
      brokerValue: "",
      Redirect: false,
      dateErrorText: "",
      cashErrorText: "",
      basketErrorText: "",
      brokerErrorText: "",
      dateFalse: false,
      cashFalse: false,
      basketFalse: false,
      brokerFalse: false,
      // buttonTitle:'واریز',
      symbols: [],
      buttonDisabled: false,
      isEdit: null,
    };

    this.fields = { value: "lable" };
    this.fields1 = { value: "lable" };
    this.fields2 = { value: "full_name" };

    this.SubmitFrom = this.SubmitFrom.bind(this);
    this.setBrokersData = this.setBrokersData.bind(this);
    this.cashchange = this.cashchange.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.editAction = this.editAction.bind(this);

    this.datepickerr = React.createRef();
  }

  convertDate(date) {
    let timee = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(date);
    let year = "";
    let month = "";
    let day = "";
    timee.forEach((element) => {
      if (element.type === "year") {
        year = element.value;
      } else if (element.type === "month") {
        month = element.value;
      } else if (element.type === "day") {
        day = element.value;
      }
    });
    let formatedDate = year + "/" + month + "/" + day;
    let pdate = moment(formatedDate, "YYYY/MM/DD").format("jYYYY-jMM-jDD");
    return pdate;
  }

  fixNumber(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  }

  dateChange(dateValue) {
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    this.setState({ dateValue: value });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.userBasketsData !== this.props.userBasketsData) {
      if (this.props.userBasketsData.length > 1) {
        this.acBaskets.readonly = false;
      } else {
        this.acBaskets.readonly = true;
      }
    }

    if (prevProps.userBrokersData !== this.props.userBrokersData) {
      if (this.props.userBrokersData.length > 1) {
        this.acBrokers.readonly = false;
      } else {
        this.acBrokers.readonly = true;
      }
    }
  }

  componentDidMount() {
    if (
      this.props.selectedBrokerId === 0 &&
      this.props.userBrokersData.length < 2
    ) {
      this.setBrokerValue(this.props.userBrokersData[0].full_name, true);
    }

    if (this.props.userBasketsData.length < 2) {
      this.setBasketValue(this.props.userBasketsData[0].lable, true);
    }
  }

  setBrokersData(data) {
    this.setState({ brokersData: data });
  }

  SubmitFrom() {
    try {
      let selectbasket = this.acBaskets.value;
      let selectbroker = this.acBrokers.value;
      let brokerid;
      let basketid;
      // let date=this.convertDate(this.state.dateValue);
      let date = moment(this.state.dateValue, "jYYYY/jMM/jDD").format(
        "jYYYY-jMM-jDD"
      );

      this.props.userBasketsData.forEach(function (entry) {
        if (entry.lable === selectbasket) {
          basketid = entry.id;
        }
      });

      this.props.userBrokersData.forEach(function (entry) {
        if (entry.full_name === selectbroker) {
          brokerid = entry.id;
        }
      });

      let cash = this.state.chashchange
        .toString()
        .replace(/,/g, "")
        .replace(/ /g, "")
        .replace(/ریال/g, "");

      if (this.state.dateValue === "") {
        this.setState({ dateFalse: true, dateErrorText: "تاریخ نامعتبر است" });
        return;
      } else {
        this.setState({ dateFalse: false, dateErrorText: "" });
      }
      if (cash === "") {
        this.setState({ cashFalse: true, cashErrorText: "مبلغ نامعتبر است" });
        return;
      } else if (Number(cash) < 1) {
        this.setState({
          cashFalse: true,
          cashErrorText: "مبلغ نمی تواند صفر باشد",
        });
        return;
      } else {
        this.setState({ cashFalse: false, cashErrorText: "" });
      }
      if (
        this.acBaskets.value === null ||
        this.acBaskets.value === "" ||
        basketid === undefined
      ) {
        this.setState({
          basketFalse: true,
          basketErrorText: "نام سبد نامعتبر است",
        });
        return;
      } else {
        this.setState({ basketFalse: false, basketErrorText: "" });
      }
      if (
        this.acBrokers.value === null ||
        this.acBrokers.value === "" ||
        brokerid === undefined
      ) {
        this.setState({
          brokerFalse: true,
          brokerErrorText: "نام کارگزاری نامعتبر است",
        });
        return;
      } else {
        this.setState({ brokerFalse: false, brokerErrorText: "" });
      }

      let data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        cash_change: cash,
        broker_id: brokerid,
        basket_id: basketid,
        dscr: "",
        date: date,
        type: "brokerProfit",
      };

      if (this.state.isEdit) {
        this.editAction(data, brokerid, basketid);
        return;
      }

      this.setState({ buttonDisabled: true });
      fetch("/api/transaction", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((resultt) => {
          if (resultt.status === 200) {
            this.props.onRefresh();
            this.resetForm();

            toast.success("ثبت سود کارگزاری با موفقیت ثبت گردید", {
              position: toast.POSITION.BOTTOM_LEFT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
          } else if (resultt.status === 401) {
            this.setState({ Redirect: true });
          } else {
            toast.error(resultt.message, {
              position: toast.POSITION.BOTTOM_LEFT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
          }
          this.setState({ buttonDisabled: false });
        });
    } catch (error) {
      this.setState({ buttonDisabled: false });
    }
  }

  // acBasketChange(){
  //     this.setState({selectedBasket:this.acBaskets.value});
  // }

  // acBrokerChange(){
  //     this.setState({selectedBroker:this.acBrokers.value});
  // }

  cashchange(event) {
    this.setState({ chashchange: event.target.value });
  }

  // onInClick(){
  //     this.setState({InValue:true,OutValue:false,buttonTitle:'واریز'});
  // }

  // onOutClick(){
  //     this.setState({InValue:false,OutValue:true,buttonTitle:'برداشت'});
  // }

  setBasketValue(name, readonly) {
    this.acBaskets.value = name;
    this.acBaskets.readonly = readonly;
  }

  setBrokerValue(name, readonly) {
    this.acBrokers.value = name;
    this.acBrokers.readonly = readonly;
  }

  itemTemplate(data) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <div>{data.broker_name}</div>
        {data.lable !== null &&
          data.lable !== "" &&
          data.lable !== undefined && (
            <div style={{ fontSize: "12px", color: "var(--gray1)" }}>
              {data.lable}
            </div>
          )}
      </div>
    );
  }

  cancelForm() {
    if (this.props.isPopup) {
      this.props.cancelForm();
      return;
    } else {
      this.resetForm();
    }
  }

  resetForm() {
    // if (this.props.isPopup){
    //     this.props.cancelForm();
    //     return;
    // }
    this.setState({
      chashchange: "",
      isEdit: null,
      dateErrorText: "",
      cashErrorText: "",
      basketErrorText: "",
      brokerErrorText: "",
      dateFalse: false,
      cashFalse: false,
      basketFalse: false,
      brokerFalse: false,
    });
    if (
      this.props.selectedPortfolioId === 0 &&
      this.props.userBasketsData.length > 1
    ) {
      this.acBaskets.value = null;
    }
    if (
      this.props.selectedBrokerId === 0 &&
      this.props.userBrokersData.length > 1
    ) {
      this.acBrokers.value = null;
    }
  }

  editFrom(data) {
    // if (data.type_id===1){
    //     this.setState({InValue:true,OutValue:false,buttonTitle:'واریز'})
    // }else{
    //     this.setState({InValue:false,OutValue:true,buttonTitle:'برداشت'})
    // }
    this.setState({
      chashchange: Math.abs(data.cash_change),
      dateValue: moment(data.date, "jYYYY-jMM-jDD").format("jYYYY/jMM/jDD"),
    });
    if (
      this.props.selectedPortfolioId === 0 &&
      this.props.userBasketsData.length > 1
    ) {
      this.acBaskets.value = data.basket;
    }
    if (
      this.props.selectedBrokerId === 0 &&
      this.props.userBrokersData.length > 1
    ) {
      if (data.lable !== null && data.lable !== "") {
        this.acBrokers.value = data.broker + " (" + data.lable + ")";
      } else {
        this.acBrokers.value = data.broker;
      }
    }

    this.setState({ isEdit: data });
  }

  editAction(body, brokerid, basketid) {
    let data = body;

    let d = [];
    if (this.state.isEdit.child === undefined) {
      d.push(this.state.isEdit);
    } else {
      this.state.isEdit.child.forEach((element) => {
        d.push(element);
      });
    }
    data.list = d;

    this.setState({ buttonDisabled: true });
    fetch("/api/editTransaction", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.props.onRefresh();

          this.resetForm();
          toast.success("سند با موفقیت ویرایش شد", {
            position: toast.POSITION.BOTTOM_LEFT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        } else if (resultt.status === 401) {
          this.setState({ Redirect: true });
        } else {
          toast.error(resultt.message, {
            position: toast.POSITION.BOTTOM_LEFT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
        this.setState({ buttonDisabled: false });
      })
      .catch((err) => {
        this.setState({ buttonDisabled: false });
      });
  }

  // brokerChange(data){
  //     if (data.itemData!==null && data.itemData.lable!==undefined && data.itemData.lable!==null){
  //         this.setState({selectedLable:data.itemData.lable})
  //     }else{
  //         this.setState({selectedLable:null})
  //     }

  //     console.log(data);
  // }

  render() {
    if (this.state.Redirect) return <Redirect to="/Login" />;
    return (
      <div className="contentStyle">
        <div id="componentsParent" style={{ minHeight: "340px" }}>
          <div className="InputWithIcon" style={{ direction: "ltr" }}>
            <div className="inputImageDiv">
              <img src={dateicon} className="inputImage" alt="date" />
            </div>
            {/* <DatePicker
                            className={this.state.dateFalse ? "form-control inputStyleRed":"form-control inputStyleForm"}
                            timePicker={false}
                            isGregorian={false}
                            ref={(scope) => this.datepickerr = scope}
                            onChange={valuee => this.dateChange(valuee)}
                            value={this.state.dateValue}
                            max={this.state.maxDateStart}
                            /> */}
            <DatePicker
              ref={this.datepickerr}
              value={this.state.dateValue}
              inputClass={
                this.state.dateFalse
                  ? "form-control inputStyleRed"
                  : "form-control inputStyleForm"
              }
              calendar="persian"
              locale="fa"
              weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
              format="YYYY/MM/DD"
              animation
              className={this.props.isPopup ? "rmdp-mobile bluee" : "bluee"}
              onChange={(valuee) => this.dateChange(valuee)}
              maxDate={this.state.maxDateStart}
              editable={false}
              inputMode="none"
              fixMainPosition={true}
              fixRelativePosition={true}
              placeholder="تاریخ"
            />
          </div>
          <div className="errorMessage1">{this.state.dateErrorText}</div>
          <NumberFormat
            placeholder="مبلغ"
            className={
              this.state.cashFalse
                ? "form-control inputStyleRed"
                : "form-control inputStyleForm"
            }
            displayType={"input"}
            thousandSeparator={true}
            suffix={" ریال"}
            onChange={this.cashchange}
            value={this.state.chashchange}
          />
          <div className="errorMessage1">{this.state.cashErrorText}</div>

          <AutoCompleteComponent
            showPopupButton={true}
            className={
              this.state.basketFalse ? "inputStyleRed" : "inputStyleForm"
            }
            allowCustom={true}
            ref={(scope) => (this.acBaskets = scope)}
            filterType="Contains"
            enableRtl="true"
            noRecordsTemplate="موردی یافت نشد"
            popupHeight="550px"
            dataSource={this.props.userBasketsData}
            fields={this.fields1}
            placeholder="سبد"
            autofill={true}
          />
          <div className="errorMessage1">{this.state.basketErrorText}</div>
          <AutoCompleteComponent
            showPopupButton={true}
            itemTemplate={this.itemTemplate}
            className={
              this.state.brokerFalse ? "inputStyleRed" : "inputStyleForm"
            }
            allowCustom={true}
            ref={(scope) => (this.acBrokers = scope)}
            filterType="Contains"
            enableRtl="true"
            noRecordsTemplate="موردی یافت نشد"
            popupHeight="550px"
            dataSource={this.props.userBrokersData}
            fields={this.fields2}
            placeholder="کارگزاری"
            autofill={true}
          />
          <div className="errorMessage1">{this.state.brokerErrorText}</div>

          {!this.state.isEdit && !this.props.isPopup && (
            <Button
              variant="secondary"
              className="formButtonStyle"
              disabled={this.state.buttonDisabled}
              onClick={this.SubmitFrom.bind(this)}
            >
              {this.state.buttonDisabled && (
                <Spinner className="spinnerStyle" animation="border" />
              )}
              {!this.state.buttonDisabled && <div>ثبت سود کارگزاری</div>}
            </Button>
          )}

          {(this.state.isEdit || this.props.isPopup) && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "20px",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Button
                variant="danger"
                onClick={this.cancelForm.bind(this)}
                style={{ minWidth: "45%", fontSize: "13px", height: "30px" }}
              >
                انصراف
              </Button>
              <div style={{ width: "10px" }} />
              <Button
                variant={this.state.isEdit ? "primary" : "secondary"}
                style={{ minWidth: "45%", fontSize: "13px", height: "30px" }}
                disabled={this.state.buttonDisabled}
                onClick={this.SubmitFrom.bind(this)}
              >
                {this.state.buttonDisabled && (
                  <Spinner className="spinnerStyle" animation="border" />
                )}
                {!this.state.buttonDisabled && this.state.isEdit && (
                  <div>ویرایش</div>
                )}
                {!this.state.buttonDisabled && !this.state.isEdit && (
                  <div>ثبت&nbsp;{this.state.buttonTitle}</div>
                )}
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}
